import { contacts } from '@/settings'
import popupPolicyHtml from './popupPolicyHtml'
import homePage from './homePage'
import projects from './projects'
import reviews from './reviews'
import privacyContent from '!!raw-loader!@/service/content/en/privacy.html'

export default {
	// Импорт:
	popupPolicyHtml,
	homePage,
	projects,
	reviews,

	// Общие фразы:
	viewProjects: 'View projects',
	discussIdea: 'Discuss Ideas',
	discussProject: 'Discuss project',
	sendRequest: 'Send request',
	leaveRequest: 'Submit',
	back: 'Back',
	excellent: 'Well done!',
	userAgreement: 'Terms of use',
	privacyPolicy: 'Privacy policy',
	TextITN: 'ITN',
	TextPSRN: 'PSRNSP',
	selected: 'Selected',
	apply: 'Apply',
	clear: 'Clear',
	categories: 'Categories',
	allСategories: 'All categories',
	selectCategories: 'Choose categories',
	and: 'and',
	thanks: 'Thank you!',
	see: 'Look',
	expand: 'More',
	narrow: 'Less',

	// Инфа о компании, контакты и пр:
	company: {
		name: 'Global Code',
		slogan: 'Unite companies and people',
		officialName: 'individual entrepreneur Filimonov A.A.',
		ITN: contacts.ITN,
		PSRN: contacts.PSRN,
		email: contacts.email,
		whatsapp: contacts.whatsapp,
		phone: contacts.phone,
		vk: contacts.vk,
		facebook: contacts.facebook,
		instagram: contacts.instagram,
		youtube: contacts.youtube,
		telegram: contacts.telegram,
	},

	// Меню:
	menu: {
		homePage: 'Home',
		menu: 'Menu',
		projects: 'Projects',
		team: 'Team',
		services: 'Services',
		reviews: 'Reviews',
		contacts: 'Contact Information',
		contactsShort: 'Contact us',
		call: 'Request a call',
	},

	// Форма:
	form: {
		enterPhone: 'Enter your phone number',
		enterName: 'Enter your name',
		attachFile: 'Attach file',
		attachFileText: 'Attache project specifications (in case you have some)',
		attachFileTextMobile:
			'If you do not have technical data for calculation, but have an estimate or specifications, attach these documents',
		enterComment: 'Leave a comment',
		recaptchaText: 'This site is protected by reCAPTCHA from Google.',
		occurredErrors: 'Errors while submitting the form',
		successfullySent: 'Your application has been successfully sent',
		send: 'Send application',
		sending: 'Sending...',
		choosedFiles: '{amount} file(s) selected',
		phoneFormatError: 'The phone number is not in the correct format',
		maxFilesError:
			'You have uploaded too many files. Max. number of files to download is {maxFiles}',
		privacyAgreement: {
			text: 'I agree to',
			link: 'the terms of the privacy policy',
			error: 'Give your consent',
		},
	},

	cookiesTooltip: {
		text: 'We use cookies to ensure fast and convenient operation of the site. By continuing to use the site, you agree to the use of cookies.',
		link: 'More.',
		btn: 'Accept',
	},

	// Страницы проектов:
	projectsPage: {
		title: 'Projects',
		site: 'Website',
		iosApp: 'IOS App',
		androidApp: 'Android App',
	},

	// Страницы и карточки отзывов:
	reviewsPage: {
		title: 'Reviews',
		allReviews: 'All Reviews',
		contactCustomer: 'Contact Сlient',
		projectCase: 'Project Case',
		completedProjects: 'Completed Projects',
		apps: 'Apps',
		site: 'Website',
		socials: 'Social Networks',
		task: 'Main task',
		coopDuration: 'Work together',
	},

	privacyPage: {
		title: 'Personal data processing policy',
		content: privacyContent,
	},
}
